import { createRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { rootRoute } from '@/router/root-route';
import ProgramCreatePage from '@/features/programs/program-create/ProgramCreatePage';

const programCreateSearchSchema = z.object({
  companyId: z.string().uuid().optional(),
});

export const programCreateRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/programas/novo',
  validateSearch: programCreateSearchSchema,
  component: ProgramCreatePage,
});
